interface OptimisticLoadingIndicatorProps {
  isVisible: boolean;
  message?: string;
}

export function OptimisticLoadingIndicator({
  isVisible,
  message = 'Updating results...',
}: OptimisticLoadingIndicatorProps) {
  if (!isVisible) return null;

  return (
    <div className="border-b border-blue-200 bg-blue-50 px-4 py-2">
      <div className="flex items-center gap-2 text-sm text-blue-700">
        <div className="h-4 w-4 animate-spin rounded-full border-2 border-blue-300 border-t-blue-600"></div>
        <span>{message}</span>
      </div>
    </div>
  );
}
